import { inject,Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { graphql, SearchResultUnion } from 'app/shared/graph';
import { GraphDotnetService } from 'app/shared/graph';

@Injectable({ providedIn: 'root' })
export class SearchService {
    private readonly graphDotnetService = inject(GraphDotnetService);


    search(query: string, storeId: string | null): Observable<SearchResultUnion[]> {
        return this.graphDotnetService.query(graphql`
                query search($query: String!, $storeId: String) {
                    search(query: $query, storeId: $storeId) {
                        __typename
                        ... on OrderSearchResult {
                            hubOrderId
                            storeId
                            storeOrderId
                        }
                        ... on OrderLineSearchResult {
                            hubLineId
                            hubOrderId
                            storeId
                            storeOrderId
                            storeOrderLineNumber
                            fulfillerHubLineNumber
                        }
                        ... on UserSearchResult {
                            hubUserId
                            storeId
                            storeUserId
                        }
                        ... on PhotoSearchResult {
                            storeId
                            photoUrn
                        }
                        ... on ProjectSearchResult {
                            storeId
                            projectId
                        }
                        ... on SharedProjectSearchResult {
                            storeId
                            sharedProjectId
                        }
                        ... on SubscriptionSearchResult {
                            subscriptionId
                            subscriptionLabel
                        }
                        ... on StoreSearchResult {
                            storeId
                            storeLabel
                            subscriptionId
                            subscriptionLabel
                        }
                    }
                }
            `,
            { query, storeId }
        ).pipe(map(q => q.search));
    }
}
